export default {"src":"/_next/static/media/IconLargeMXBoots.a8f92a5e.svg","height":47,"width":53,"blurWidth":0,"blurHeight":0};